import PhoneInput from "react-phone-input-2";

const PhoneInput2 = PhoneInput;
export default PhoneInput2;
